export interface IOrder {
  id: number;
  status: string;
  totalAmount: string;
  sessionId: string;
  ttn: string;
  city: string;
  adress: string;
  eircode: string;
  invoice?: string;
  createdAt: Date;
  updatedAt: Date;
  items: Array<{
    id: string;
    quantity: number;
    product: {
      id: string;
      name: string;
      description: string;
      shortDescription: string;
      capacity: string;
      howToUse: string;
      fullIngredientsList: string;
      previewImageUrl: string;
      imagesUrls: Array<string>;
      price: string;
      bookedQuantity: number;
      wholeSalePrice: string;
      avaliable: boolean;
      skinType: string;
      createdAt: string;
      updatedAt: string;
    };
  }>;
  client: {
    id: string;
    fullName: string;
    email: string;
    phone: string;
    avatarUrl: string;
    createdAt: string;
    updatedAt: string;
    savedProducts: Array<any>;
    note: any;
    adress: any;
    premiumStatus: string;
    discount: string;
  };
  adressLine1: string;
  adressLine2: string;
  country: string;
  postalCode: string;
  state: string;
}

export enum OrderStatus {
  PENDING = "pending", // Очікує оплати
  PAID = "paid", // Оплачено
  PREPARING = "preparing", // Готується до відправки
  PACKED = "packed", // Упаковано
  SHIPPED = "shipped", // Відправлено
  DELIVERED = "delivered", // Доставлено
  RECEIVED = "received", // Отримано
  CANCELED = "canceled", // Скасовано
}

export interface IProccessingResponse {
  order: {
    id: number;
    status: string;
    totalAmount: string;
    sessionId: string;
    ttn: any;
    city: any;
    adress: any;
    eircode: any;
    createdAt: string;
    updatedAt: string;
  };
  id: string;
  createdAt: string;
}

export interface IProccessingCreateDto {
  orderId: number;
}

export interface IBatchIdsWriteOff {
  batchId: string;
  quantity: number;
}

export interface IWriteOffProductsOrder {
  processingId: string;
  batchIds: IBatchIdsWriteOff[];
  userId: string;
}

/** Оновлення замовлення (PUT /orders/update/:id). Усі поля опціональні — передаються лише змінені. */
export interface IOrderUpdateDto {
  status?: string;
  invoice?: string;
  /** ISO 8601, наприклад 2024-01-15T12:00:00.000Z */
  createdAt?: string;
  clientPhone?: string;
  clientFullName?: string;
  adressLine1?: string;
  adressLine2?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  country?: string;
}

/** @deprecated Використовуйте IOrderUpdateDto */
export type IOrderUpdateStatus = IOrderUpdateDto;

export interface IOrderShipped {
  ttn: string;
}

export interface IOrderPhoneCreateDto {
  clientPhone: string;
  clientFullName: string;
  status?: string;
  totalAmount?: number;
  ttn?: string;
  adressLine1?: string;
  adressLine2?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  country?: string;
  orderProducts: Array<{
    productId: string;
    quantity: number;
  }>;
}
